import { render, staticRenderFns } from "./capture-point.vue?vue&type=template&id=a2a33816&scoped=true&lang=pug&"
import script from "./capture-point.vue?vue&type=script&lang=js&"
export * from "./capture-point.vue?vue&type=script&lang=js&"
import style0 from "./capture-point.vue?vue&type=style&index=0&id=a2a33816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a33816",
  null
  
)

/* custom blocks */
import block0 from "./capture-point.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFormsAddress: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/address.vue').default,WidgetsFormsField: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/field.vue').default,ProductsBroadbandMultiSelectDropdown: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/products/broadband/multi-select-dropdown.vue').default,WidgetsFormsButton: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/button.vue').default,SiteFeefoMini: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/site/feefo-mini.vue').default,ProductsPillCta: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/products/pill-cta.vue').default})
